import RouteRecord from '@/orm/models/RouteRecord'

/**
 * This is a faux model used in the interface for the Sustainability Dashboard routes index page so that we can
 * use the js-data orm via RemoteDataTableMixin, even though we're not using a typical CRUD resource on the remote end.
 * This lets us interface with the endpoint via PagedCollection in a straightforward way, as well.
 */
class SustainabilityRouteRecord extends RouteRecord {
  static get endpoint () { return 'sustainability-insights/routes' }
}
export default SustainabilityRouteRecord
